import Loadable from 'react-loadable';

export const FulfillmentApiDoc = Loadable({
  loader: () => import('./FulfillmentApiDoc'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/containers/FulfillmentApiDoc/index.tsx